/*!
 * ETAR theme v4.2.4 — Search page hero (field + atomiser that sprays while typing)
 * Developed by FACTICIED · https://www.facticied.com
 */
(() => {
  if (customElements.get('et-search-hero')) return;

  class EtSearchHero extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      const opt = { signal: this.ac.signal };
      this.spray = this.querySelector('[data-spray]');
      this.input = this.querySelector('[data-search-input]');
      this.clear = this.querySelector('[data-search-clear]');
      const still = document.documentElement.classList.contains('et-no-motion') || matchMedia('(prefers-reduced-motion: reduce)').matches;
      let last = 0;

      if (this.input) {
        this.input.addEventListener('input', () => {
          if (this.clear) this.clear.hidden = this.input.value === '';
          /* a puff of mist, at most every 600 ms */
          const now = performance.now();
          if (this.spray && !still && now - last > 600) {
            last = now;
            this.spray.classList.remove('is-spray');
            void this.spray.offsetWidth;
            this.spray.classList.add('is-spray');
          }
        }, opt);
      }
      this.clear?.addEventListener('click', () => {
        this.input.value = '';
        this.clear.hidden = true;
        this.input.focus();
      }, opt);
      this.querySelector('[data-search-form]')?.addEventListener('submit', (e) => {
        if (!this.input.value.trim()) { e.preventDefault(); this.input.focus(); }
      }, opt);
    }

    disconnectedCallback() { this.ac?.abort(); }
  }

  customElements.define('et-search-hero', EtSearchHero);
})();
